import { useURLFilterState } from '@client/hooks/useURLFilterState';

const TREATMENT_FILTERS = [
  'cultures',
  'cultural_practices',
  'treatment_types',
  'application_types',
  'intervention_periods',

  //Extra filters Agronomic
  'enemies',
  'commercial_products',
  'active_substances',
  'pesticide_groups',
  'culture_stages',
  'organic_approval',
  'soil_types',
  'intercrop_cultures',

  // Weeds groups for herbicides
  'weeds_group_enemies',
  'annual_grasses',
  'annual_broadleaves',
  'perennial_grasses',
  'perennial_broadleaves',
  'other_weeds',

  // Application details
  'application_methods',
  'application_zones',
  'surfaces_to_treat',
  'techniques_or_application_places',

  'acute_toxicity',
  'long_term_effects',
  'fish_or_daphnia',
  'birds',
  'bees',
  'persistence',
  'leaching_potential',
];

export const useTreatmentFilters = () => {
  return useURLFilterState(TREATMENT_FILTERS, {
    defaultPagination: { page: 1, size: 20 },
    throttleMs: 300,
    clearOnDefault: true,
  });
};
